import { render } from "./DataMapperInvocations.vue?vue&type=template&id=783ff50a&scoped=true"
import script from "./DataMapperInvocations.vue?vue&type=script&lang=js"
export * from "./DataMapperInvocations.vue?vue&type=script&lang=js"

import "./DataMapperInvocations.vue?vue&type=style&index=0&id=783ff50a&scoped=true&lang=css"
import "./DataMapperInvocations.vue?vue&type=style&index=1&id=783ff50a&lang=scss"
import "./DataMapperInvocations.vue?vue&type=style&index=2&id=783ff50a&lang=scss"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-783ff50a"]])

export default __exports__